import { useEffect, useState } from "react";
import { FileText, Search, X, Plus } from "lucide-react";
import api from "../../lib/api";
import Modal from "../Modal";
import { toast } from "sonner";

export default function DatasheetPickerModal({ onPick, onClose }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/datasheets", { params: q ? { q } : {} });
      setItems(r.data?.items || []);
    } catch (err) {
      toast.error("Could not load library.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const t = setTimeout(load, 250);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q]);

  return (
    <Modal open onClose={onClose} title="Insert datasheet from library" testId="ds-picker-modal" maxWidth="max-w-3xl">
      <div className="space-y-3">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#647087]" />
          <input
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search title, manufacturer, part #, tags…"
            className="hv-input hv-input-search"
            data-testid="ds-picker-search"
            autoFocus
          />
        </div>
        {loading ? (
          <div className="text-center text-[#647087] py-12 text-sm">Loading…</div>
        ) : items.length === 0 ? (
          <div className="text-center text-[#647087] py-12 text-sm">
            <FileText className="w-8 h-8 mx-auto mb-2 opacity-50" />
            No datasheets found. Upload one in <span className="text-[#1fb6c1]">Equipment & Inventory → Datasheets</span>.
          </div>
        ) : (
          <div className="max-h-[60vh] overflow-y-auto space-y-1.5">
            {items.map((d) => (
              <button
                key={d.id}
                type="button"
                onClick={() => onPick(d)}
                className="w-full text-left p-3 rounded-md border border-white/10 hover:border-[#1fb6c1]/40 hover:bg-[#1fb6c1]/5 transition flex items-start gap-3"
                data-testid={`ds-picker-item-${d.id}`}
              >
                <FileText className="w-5 h-5 text-[#1fb6c1] flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <div className="font-display font-bold text-sm truncate">{d.title}</div>
                  <div className="flex items-center gap-2 flex-wrap mt-0.5">
                    {d.manufacturer && (
                      <span className="text-[10px] uppercase tracking-wider text-[#A78BFA]">{d.manufacturer}</span>
                    )}
                    {d.part_number && (
                      <span className="text-[10px] font-mono text-[#1fb6c1]">{d.part_number}</span>
                    )}
                    <span className="text-[10px] uppercase tracking-wider text-[#647087]">{d.category}</span>
                  </div>
                  {d.summary && (
                    <div className="text-[11px] text-[#a0aabf] line-clamp-2 mt-1">{d.summary}</div>
                  )}
                </div>
                <Plus className="w-4 h-4 text-[#1fb6c1] flex-shrink-0 mt-1" />
              </button>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
